import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Judet, JudetUpdate } from './judet.interface';

@Injectable({
  providedIn: 'root'
})
export class JudetService {
  private token!: string;
  private httpOptions: any;
  
  private basePath = environment.interop.basePath;

  //Getters
  private getJudetDTURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteDT;
  private getJudetURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudet;
  private getActiveJudeteURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteActive;
  private getPublicJudeteURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.getJudeteActivePublic;

  //Update
  private storeJudetURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.storeJudet;
  private updateJudetURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.putJudet;
  private updateStatusJudetActiveURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.changeStatusJudetActive;
  private updateStatusJudetPublicURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.changeStatusJudetPublic;

  private deleteJudetURL = this.basePath + environment.interop.urbanism.nomenclatoare.judet.deleteJudet;


  constructor(private http: HttpClient) {}

  getJudeteDT() {
    return this.http.get(this.getJudetDTURL, this.httpOptions);
  }

  addJudet(judet: Judet) {
    return this.http.post(this.storeJudetURL, judet, this.httpOptions);
  }

  getActiveJudete() {
    return this.http.get(this.getActiveJudeteURL, this.httpOptions);
  }

  getPublicJudete() {
    return this.http.get(this.getPublicJudeteURL, this.httpOptions);
  }

  updateJudet(judet: JudetUpdate) {
    return this.http.put(this.updateJudetURL, judet, this.httpOptions);
  }

  updateStatusActiveJudet(judet: any) {
    return this.http.post(this.updateStatusJudetActiveURL, judet, this.httpOptions);
  }

  updateStatusPublicJudet(judet: any) {
    return this.http.post(this.updateStatusJudetPublicURL, judet, this.httpOptions);
  }

  deleteJudet(judetId: number) {
    return this.http.delete(this.deleteJudetURL + judetId);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
